const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/user/login-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { LoginLogFilterParamSchema } from '@apps/main/features/admin/pages/user/login-log-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/user/login-log')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: LoginLogFilterParamSchema
});